import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Receipt, Users, Scan, ShieldCheck, Clock, MessageSquare, Plane, FileText } from "lucide-react";
const coreValues = [{
  icon: Receipt,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#14b8a6]/15 text-[#14b8a6] border-[#14b8a6]/30",
  gridSpan: "md:col-span-2 md:row-span-2",
  title: "Listino per voce",
  description: "Ogni voce ha il suo prezzo: impianto, corona, arcata. Il totale per il tuo caso è scritto nel piano prima della partenza."
}, {
  icon: Users,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#c9a227]/15 text-[#c9a227] border-[#c9a227]/30",
  gridSpan: "md:col-span-2 md:row-span-1",
  title: "Équipe dedicata",
  description: "Chirurghi e protesisti che seguono il tuo caso dalla pianificazione ai controlli."
}, {
  icon: Scan,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#14b8a6]/15 text-[#14b8a6] border-[#14b8a6]/30",
  gridSpan: "md:col-span-1 md:row-span-1",
  title: "Tecnologia 3D",
  description: "Pianificazione digitale con scanner intraorale e CBCT."
}, {
  icon: ShieldCheck,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#c9a227]/15 text-[#c9a227] border-[#c9a227]/30",
  gridSpan: "md:col-span-1 md:row-span-1",
  title: "Materiali Certificati",
  description: "Sistema implantare dichiarato con il codice nel piano (ad esempio Nobel Biocare, Alpha Bio o Straumann)."
}, {
  icon: Clock,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#14b8a6]/15 text-[#14b8a6] border-[#14b8a6]/30",
  gridSpan: "md:col-span-1 md:row-span-1",
  title: "Denti Fissi in 24h",
  description: "Protocolli di carico immediato con denti provvisori fissi entro 24 ore, quando il clinico li ritiene indicati per il tuo caso."
}, {
  icon: MessageSquare,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#c9a227]/15 text-[#c9a227] border-[#c9a227]/30",
  gridSpan: "md:col-span-1 md:row-span-1",
  title: "Staff Madrelingua",
  description: "Un referente che parla italiano, dal primo messaggio ai controlli."
}, {
  icon: Plane,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#14b8a6]/15 text-[#14b8a6] border-[#14b8a6]/30",
  gridSpan: "md:col-span-2 md:row-span-1",
  title: "Turismo Dentale",
  description: "Transfer dall'aeroporto e alloggio in hotel convenzionati, organizzati dalla clinica."
}, {
  icon: FileText,
  cardBg: "bg-gradient-to-br from-[#0f172a] to-[#1e293b]",
  gradientClass: "bg-[#c9a227]/15 text-[#c9a227] border-[#c9a227]/30",
  gridSpan: "md:col-span-4 md:row-span-1",
  title: "Tutto per iscritto",
  description: "Piano, voci di prezzo, calendario dei controlli e condizioni di garanzia: tutto per iscritto, prima di partire."
}];
export default function OurCoreValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="234569" id="criteri-di-selezione-e-superamento-dubbi" className="bg-background text-foreground py-20 md:py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-4 tracking-tight text-primary">
            8 Vantaggi Reali di Scegliere l'Albania
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            Non tutte le cliniche sono uguali. Ecco cosa verificare prima di scegliere.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {coreValues.map((value, i) => <Card key={i} data-index={i} style={{
          transitionDelay: isVisible ? `${i * 75}ms` : "0ms"
        }} className={cn("text-card-foreground border border-white/[0.08] rounded-xl shadow-sm hover:translate-y-[-4px] hover:shadow-2xl hover:border-primary/30 transition-all duration-300 group overflow-hidden relative p-5 sm:p-6 flex flex-col justify-start gap-3 h-full", value.cardBg, isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6", value.gridSpan)}>
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

              <CardHeader className="p-0 pb-1 relative z-10 gap-1.5">
                <div className={cn("size-12 rounded-lg flex items-center justify-center mb-1.5 shadow-xs border border-border/40 transition-transform duration-300 group-hover:scale-105", value.gradientClass)}>
                  <value.icon className="size-6" />
                </div>
                <CardTitle className="text-2xl font-serif tracking-tight text-white">
                  {value.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0 relative z-10">
                <p className="text-slate-300 leading-relaxed font-default text-base">
                  {value.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}